<div *ngIf="controlData.dropdownSearchEnabled">
    <input type="text" (click)="controlsSelector.open()" [(ngModel)]="selectionName"
        class="form-control selection-input" [disabled]="isReadOnly" >
        <div class="mat-select-arrow selection-input-arrow"></div>
    <div class="selection-panel">

        <mat-select [formControl]="controlsFormCtrl" [multiple]="false" [disabled]="isReadOnly" #controlsSelector>
            <mat-option>
                <ngx-mat-select-search noEntriesFoundLabel="No results found" placeholderLabel="Find..." [formControl]="controlsFilterForm">
                </ngx-mat-select-search>
            </mat-option>
            <ng-container *ngIf="controlData.dataSetEnabled; else customOptions">
                <mat-option *ngFor="let item of filteredControls | async" [value]="item" (click)="selectControl(item)" class="cust-mat-option">
                  {{ item.display.fieldValue }}
                </mat-option>
              </ng-container>
              <ng-template #customOptions>
                <mat-option *ngFor="let item of filteredControls | async" [value]="item.display" (click)="selectControl(item.display)" class="cust-mat-option">
                  {{ item.display }}
                </mat-option>
              </ng-template>
        </mat-select>
    </div>
</div>
<div *ngIf="!controlData.dropdownSearchEnabled">
    <mat-select
        [compareWith]="compareWith"
        class="form-control"
        [(ngModel)]="selectionName"
        (selectionChange)="selectControl($event.value)"
        [disabled]="isReadOnly"
    >
        <ng-container *ngIf="controlData.dataSetEnabled; else customOptions">
        <mat-option *ngFor="let item of controlData.options" [value]="item">
            {{ item.display.fieldValue }}
        </mat-option>
        </ng-container>
        <ng-template #customOptions>
        <mat-option *ngFor="let item of controlData.options" [value]="item.display">
            {{ item.display }}
        </mat-option>
        </ng-template>
    </mat-select>
</div>
